import React from "react";

import { Card, CardBody, CardHeader, CardTitle } from "reactstrap";

import { BEM } from "helpers/BEM.helper";
import RegisterForm from "views/pages/Register/RegisterForm";

const RegisterCard: React.FC = () => {
  const classes = new BEM({
    block: { name: "RegisterCard" },
    elements: [{ name: "title" }],
  });

  return (
    <Card className="card-signup text-center">
      <CardHeader>
        <CardTitle tag="h4" className={classes.getElementClassNames("title")}>
          Register
        </CardTitle>
      </CardHeader>
      <CardBody>
        <RegisterForm />
      </CardBody>
    </Card>
  );
};

export default RegisterCard;
